// De Brabandere scroll-reveal — onthult .dbb-fade-elementen één keer (permanent)
// zodra ze in beeld komen. IntersectionObserver = robuust ongeacht de
// scroll-container. Alleen actief op .dbb-fade (debrabandere-gescoped).
document.addEventListener("DOMContentLoaded", () => {
  const els = document.querySelectorAll(".dbb-fade");
  if (!els.length) return;

  // Geen observer-support → meteen tonen.
  if (!("IntersectionObserver" in window)) {
    els.forEach((el) => el.classList.add("is-visible"));
    return;
  }

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          io.unobserve(entry.target); // permanent — niet opnieuw verbergen
        }
      });
    },
    { threshold: 0, rootMargin: "0px 0px -8% 0px" }
  );

  // Alles wat bij het laden al (deels) in beeld staat → meteen tonen, zonder
  // op scroll te wachten. De rest faden in zodra ze in beeld scrollen.
  const vh = window.innerHeight || document.documentElement.clientHeight;
  els.forEach((el) => {
    const r = el.getBoundingClientRect();
    if (r.top < vh && r.bottom > 0) {
      el.classList.add("is-visible");
    } else {
      io.observe(el);
    }
  });
});
